<template>
  <div>
    <RadioGroup v-model="selectValue" @on-change="getSelect">
      <Radio :label="ele.code" v-for="(ele, index) in dicList" :key="index">{{ ele.name }}</Radio>
    </RadioGroup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    dicName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectValue: '',
      appCode: 'bsp',
      dicList: []
    }
  },
  watch: {
    dicName: {
      handler(n, o) {
        n ? this.getData() : ''
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(n, o) {
        if (n) {
          this.$set(this, 'selectValue', n)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData() {
      this.$store
        .dispatch('authGetRequest', {
          url: `/bsp-com/static/dic/${this.appCode}/${this.dicName}.js`
        })
        .then(res => {
          let arr = []
          let numTon = eval('(' + res + ')')
          arr = numTon()
          this.dicList = arr
        })
    },
    getSelect(data) {
      this.$emit('input', this.selectValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/component/data-grid/components/data-radio.vue